












import { Component, Prop, Watch, Mixins, Vue } from "vue-property-decorator";

@Component
export default class Breadcrumb extends Vue
{
    /**
     * 路由名称
     * @protected
     */
    protected name: string = "";

    /**
     * 路由名称
     * @protected
     * @returns Array<any>
     */
    protected breadList: Array<any> = [];

    /**
     * 组件创建钩子
     * @protected
     */
    protected created()
    {
        this.getBreadcrumb()
    }

    /**
     * 获取路由数据
     * @protected
     * @returns void
     */
    protected getBreadcrumb(): void
    {
        this.breadList = []
        this.name = this.$route.name;
        
        this.$route.matched.forEach(item => {
            this.breadList.push(item)
        })
        
    }

    /**
     *  路由发生变化
     * @protected
     * @returns void
     */
    @Watch("$route")
    protected onRouteChange():void
    {
        this.getBreadcrumb();
    }
    
}

